<template>
  <div class="infoBlock">
    <div class="infoBlock__sideDecor" />
    <div class="infoBlock__content">
      <slot />
    </div>
  </div>
</template>
<script setup></script>
<style lang="scss" scoped>
.infoBlock {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  overflow: hidden;

  &__sideDecor {
    width: 15px;
    background-color: $blue-80;
  }

  &__content {
    padding: 1rem;
    background-color: $black-10;
  }
}
</style>
